module.exports = __webpack_public_path__ + "static/media/ss1.cc672a8a.jpg";